<!--suppress ALL -->
<template>
  <div>
    <div class="page case-detail__content">
      <div class="padding15 bg-content m-b-24">
        <el-button type="primary" size="small" @click="addClick" v-if="this.$hasPerm('B018&1')">添加</el-button>
        <div class="bg-content padding15">
          <el-form size="small" label-width="100px" ref="searchRef">
            <el-row :gutter="12">
              <el-col :span="8" v-if="this.$partB()">
                <el-form-item label="公司">
                  <el-select v-model="searchReq.companyId" filterable clearable placeholder="请选择" style="width: 100%;">
                    <el-option
                      v-for="item in companyNameList"
                      :key="item.id"
                      :label="item.companyName"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="状态">
                  <el-select v-model="searchReq.status" filterable clearable placeholder="请选择" style="width: 100%;">
                    <el-option
                      v-for="item in stateList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 按钮操作 -->
              <div class="padding15-tb text right">
                <el-button type="primary" size="small" plain @click="searchReq.page = 1; getList();"><i class="fa fa-search"></i> 搜索</el-button>
                <el-button size="small" @click="reset">重置</el-button>
              </div>
            </el-row>
          </el-form>
        </div>

        <div class="padding15 bg-content">
          <el-table size="small" :data="configlist.list" v-loading="loading">
            <el-table-column fixed property="companyName" min-width="100" label="公司" align="center"/>
            <el-table-column fixed property="groupName" min-width="120" label="策略组" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.groupName">{{ scope.row.groupName }}</span>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column  property="pullTime"  label="拉取时间" align="center" >
              <template slot-scope="scope">
                <span v-if="scope.row.pullTime">{{ scope.row.pullTime }}</span>
                <span v-else>无限制</span>
              </template>
            </el-table-column>
            <el-table-column  property="account"  label="账号" align="center" />
            <el-table-column  property="orgCode"  label="组别" align="center" />
            <el-table-column  property="orgPwd"  label="机构密码" align="center" />
            <el-table-column  property="overdueDates"  label="逾期天数" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.overdueDates">{{ scope.row.overdueDates }}</span>
                <span v-else>无限制</span>
              </template>
            </el-table-column>
            <el-table-column  property="overdueAmountStart"  label="逾期金额起" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.overdueAmountStart">{{ scope.row.overdueAmountStart }}</span>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column  property="overdueAmountEnd"  label="逾期金额止" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.overdueAmountEnd">{{ scope.row.overdueAmountEnd }}</span>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column  property="status"  label="状态"  align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.status">启用</span>
                <span v-else>禁用</span>
              </template>
            </el-table-column>
            <el-table-column  property="createTime"  label="创建时间" min-width="120" align="center"/>
            <el-table-column fixed="right" label="操作" min-width="100" align="center" v-if="this.$hasPerm('B018&2')">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="addButton(scope.row)"><i class="el-icon-plus"></i>&nbsp;新增</el-button>
                <el-button type="text" size="small" @click="updateButton(scope.row)"><i class="el-icon-edit-outline"></i>&nbsp;编辑</el-button>
                <el-button type="text" size="small" @click="deleteButton(scope.row.id)"><i class="el-icon-delete"></i>&nbsp;删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="text center margin15-tb">
            <el-pagination
              background
              layout="prev, pager, next, sizes, total"
              :total="configlist.totalRecords"
              :page-size="searchReq.limit"
              :current-page="searchReq.page"
              @current-change="currentChange"
              @size-change="sizeChange">
            </el-pagination>
          </div>
        </div>
        <!-- 添加/编辑定时任务 -->
        <el-dialog :title="title" :visible.sync="addOrUpdateVisible" width="40%" center>
          <div>
            <el-form size="small" label-width="140px">
              <el-form-item label="公司" v-if="this.$partB()">
                <el-select v-model="addOrUpdateReq.companyId" filterable @change="sourceCompanyChange" placeholder="请选择" style="width: 100%;">
                  <el-option
                    v-for="item in companyNameList"
                    :key="item.id"
                    :label="item.companyName"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="策略组">
                <el-select v-model="addOrUpdateReq.groupId" placeholder="请选择" style="width: 100%;" filterable>
                  <el-option
                    v-for="item in groupOption"
                    :key="item.id"
                    :label="item.groupName"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="拉取时间">
                <el-time-picker
                  style="width:100%"
                  v-model="addOrUpdateReq.pullTime"
                  format="HH:mm:ss"
                  value-format="HH:mm:ss">
                </el-time-picker>
              </el-form-item>
              <el-form-item label="账号">
                <el-input placeholder="请输入账号" v-model="addOrUpdateReq.account"></el-input>
              </el-form-item>
              <el-form-item label="机构码">
                <el-input placeholder="请输入机构码" v-model="addOrUpdateReq.orgCode"></el-input>
              </el-form-item>
              <el-form-item label="密码">
                <el-input placeholder="请输入密码" v-model="addOrUpdateReq.orgPwd"></el-input>
              </el-form-item>
              <el-form-item label="逾期天数">
                <el-input placeholder="请输入逾期天数，多个逗号分割" v-model="addOrUpdateReq.overdueDates"></el-input>
              </el-form-item>
              <el-form-item label="逾期金额起">
                <el-input style="width:100%" v-model="addOrUpdateReq.overdueAmountStart" @keyup.native="numberDisStart" controls-position="right" placeholder="请输入逾期金额开始"></el-input>
              </el-form-item>
              <el-form-item label="逾期金额止">
                <el-input style="width:100%" v-model="addOrUpdateReq.overdueAmountEnd" @keyup.native="numberDisEnd" controls-position="right" placeholder="请输入逾期金额结束"></el-input>
              </el-form-item>
              <el-form-item label="状态">
                <el-switch v-model="addOrUpdateReq.status"/>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="addOrUpdateVisible = false" size="small">取 消</el-button>
            <el-button type="primary" size="small" @click="update">保存</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: true,
      searchReq: {
        companyId: null,
        status: null,
        page: 1,
        limit: 10,
        order: 'create_time',
        sort: 'desc'
      },
      configlist: { 'totalRecords': 0, list: [] },
      companyNameList: [],
      groupOption: [],
      stateList: [
        { value: 0, label: '禁用' },
        { value: 1, label: '启用' }
      ],
      addOrUpdateReq: {
        id: null,
        companyId: null,
        groupId: null,
        account: null,
        orgCode: null,
        orgPwd: null,
        overdueDates: null,
        status: null,
        overdueAmountStart: null,
        overdueAmountEnd: null,
        pullTime: null
      },
      addOrUpdateVisible: false,
      title: null,
      groupReq: {
        companyId: null
      }
    };
  },
  mounted() {
    this.getList();
    // 甲方公司
    if (this.$partA()) {
      this.addOrUpdateReq.companyId = this.$account().companyId;
      this.sourceCompanyChange();
    } else {
      this.companyList();
    }
  },
  methods: {
    getList() {
      this.loading = true;
      this.$ajax({
        method: 'POST',
        url: '/decisions/list',
        data: this.searchReq
      }).then((res) => {
        this.configlist.list = res.data.list;
        this.configlist.totalRecords = res.data.totalRecords;
        this.loading = false;
      });
    },
    addClick() {
      this.title = '添加';
      if (this.$partA()) {
        this.addOrUpdateReq.companyId = this.$account().companyId;
      } else {
        this.addOrUpdateReq.companyId = null;
      }
      this.addOrUpdateReq.id = null;
      this.addOrUpdateReq.groupId = null;
      this.addOrUpdateReq.account = null;
      this.addOrUpdateReq.orgCode = null;
      this.addOrUpdateReq.orgPwd = null;
      this.addOrUpdateReq.overdueDates = null;
      this.addOrUpdateReq.status = false;
      this.addOrUpdateReq.overdueAmountStart = null;
      this.addOrUpdateReq.overdueAmountEnd = null;
      this.addOrUpdateReq.pullTime = null;
      this.addOrUpdateVisible = true;
    },
    updateButton(row) {
      this.title = '编辑';
      this.addOrUpdateReq.id = row.id;
      this.addOrUpdateReq.companyId = row.companyId;
      this.addOrUpdateReq.groupId = row.groupId;
      this.addOrUpdateReq.account = row.account;
      this.addOrUpdateReq.orgCode = row.orgCode;
      this.addOrUpdateReq.orgPwd = row.orgPwd;
      this.addOrUpdateReq.overdueDates = row.overdueDates;
      this.addOrUpdateReq.status = row.status;
      this.addOrUpdateReq.overdueAmountStart = row.overdueAmountStart;
      this.addOrUpdateReq.overdueAmountEnd = row.overdueAmountEnd;
      this.addOrUpdateReq.pullTime = row.pullTime;
      this.sourceCompanyChange();
      this.addOrUpdateVisible = true;
    },
    addButton(row) {
      this.title = '添加';
      this.addOrUpdateReq.id = null;
      this.addOrUpdateReq.companyId = row.companyId;
      this.addOrUpdateReq.groupId = row.groupId;
      this.addOrUpdateReq.account = row.account;
      this.addOrUpdateReq.orgCode = row.orgCode;
      this.addOrUpdateReq.orgPwd = row.orgPwd;
      this.addOrUpdateReq.overdueDates = row.overdueDates;
      this.addOrUpdateReq.status = row.status;
      this.addOrUpdateReq.overdueAmountStart = row.overdueAmountStart;
      this.addOrUpdateReq.overdueAmountEnd = row.overdueAmountEnd;
      this.addOrUpdateReq.pullTime = row.pullTime;
      this.sourceCompanyChange();
      this.addOrUpdateVisible = true;
    },
    update() {
      if (this.addOrUpdateReq.overdueAmountStart && this.addOrUpdateReq.overdueAmountEnd) {
        if (this.addOrUpdateReq.overdueAmountStart >= this.addOrUpdateReq.overdueAmountEnd) {
          this.$message({
            type: 'error',
            message: '请正确输入逾期金额区间！'
          });
          return;
        }
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.$ajax({
        method: 'POST',
        url: '/decisions/addOrUpdateDecisions',
        data: this.addOrUpdateReq
      }).then(() => {
        loading.close();
        this.getList();
        this.addOrUpdateVisible = false;
      }).catch(() => {
        loading.close();
      });
    },
    deleteButton(id) {
      this.$confirm('是否确定删除此配置？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          method: 'POST',
          url: '/decisions/delete',
          params: { id }
        }).then(() => {
          this.getList();
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 重置
    reset() {
      this.searchReq.companyId = null;
      this.searchReq.status = null;
    },
    currentChange(page) {
      this.searchReq.page = page;
      this.getList();
    },
    // 显示条数
    sizeChange(num) {
      this.searchReq.limit = num;
      this.getList();
    },
    // 获取公司列表
    companyList() {
      this.$ajax({
        method: 'GET',
        url: '/company/list'
      }).then((res) => {
        this.companyNameList = res.data;
      });
    },
    sourceCompanyChange(companyId) {
      let change = false;
      // 公司变更
      if (companyId !== undefined && companyId !== this.groupReq.companyId) {
        change = true;
      }
      this.groupReq.companyId = this.addOrUpdateReq.companyId;
      this.$ajax({
        url: '/strategy/selectAllGroupsByCompanyIdOfUser',
        method: 'POST',
        data: this.groupReq
      }).then((res) => {
        this.groupOption = res.data;
        // 公司变更 策略组初始化
        if (change) {
          this.addOrUpdateReq.groupId = res.data[0].id;
        }
      });
    },
    // 校验逾期金额起
    numberDisStart() {
      this.addOrUpdateReq.overdueAmountStart = this.addOrUpdateReq.overdueAmountStart.replace(/[^\\.\d]/g, '');
      this.addOrUpdateReq.overdueAmountStart = this.addOrUpdateReq.overdueAmountStart.replace('.', '');
    },
    // 校验逾期金额止
    numberDisEnd() {
      this.addOrUpdateReq.overdueAmountEnd = this.addOrUpdateReq.overdueAmountEnd.replace(/[^\\.\d]/g, '');
      this.addOrUpdateReq.overdueAmountEnd = this.addOrUpdateReq.overdueAmountEnd.replace('.', '');
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/main/decisions/config.vue